export interface AdminVoiceUsageData {
  userId: number;
  name: string;
  username: string;
  email: string;
  groupName: string;
  sessionCount: number;
  totalDurationSeconds: number;
  lastUsedAt: string | null;
  activeSessions: number;
  voiceAccessEnabled: boolean;
}

export interface AdminVoiceSessionData {
  id: number;
  userId: number;
  userName: string;
  username: string;
  agentId?: string | null;
  voiceId?: string | null;
  startedAt: string;
  endedAt: string | null;
  durationSeconds: number;
  status: string;
}

function durationSeconds(startedAt?: string | null, endedAt?: string | null, stored?: number): number {
  const storedSeconds = Math.max(0, Number(stored) || 0);
  if (storedSeconds > 0) return storedSeconds;
  const start = startedAt ? Date.parse(startedAt) : NaN;
  if (!Number.isFinite(start) || endedAt) return storedSeconds;
  return Math.max(0, Math.round((Date.now() - start) / 1000));
}

export function mapVoiceUsage(row: any): AdminVoiceUsageData {
  return {
    userId: row.userId ?? row.UserId,
    name: row.name ?? row.Name ?? "",
    username: row.username ?? row.Username ?? "",
    email: row.email ?? row.Email ?? "",
    groupName: row.groupName ?? row.GroupName ?? "",
    sessionCount: row.sessionCount ?? row.SessionCount ?? 0,
    totalDurationSeconds: durationSeconds(null, null, row.totalDurationSeconds ?? row.TotalDurationSeconds),
    lastUsedAt: row.lastUsedAt ?? row.LastUsedAt ?? null,
    activeSessions: row.activeSessions ?? row.ActiveSessions ?? 0,
    voiceAccessEnabled: row.voiceAccessEnabled ?? row.VoiceAccessEnabled ?? true,
  };
}

export function mapVoiceSession(row: any): AdminVoiceSessionData {
  const startedAt = row.startedAt ?? row.StartedAt;
  const endedAt = row.endedAt ?? row.EndedAt ?? null;
  return {
    id: row.id ?? row.Id,
    userId: row.userId ?? row.UserId,
    userName: row.userName ?? row.UserName ?? "",
    username: row.username ?? row.Username ?? "",
    agentId: row.agentId ?? row.AgentId ?? null,
    voiceId: row.voiceId ?? row.VoiceId ?? null,
    startedAt,
    endedAt,
    durationSeconds: durationSeconds(startedAt, endedAt, row.durationSeconds ?? row.DurationSeconds),
    status: row.status ?? row.Status ?? "",
  };
}
